import { render } from "./SoftSkillsDynamics.vue?vue&type=template&id=61a9f880&scoped=true"
import script from "./SoftSkillsDynamics.vue?vue&type=script&lang=js"
export * from "./SoftSkillsDynamics.vue?vue&type=script&lang=js"

import "./SoftSkillsDynamics.vue?vue&type=style&index=0&id=61a9f880&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61a9f880"]])

export default __exports__